import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl, offerAnchor } from '../data/content';
import { trackInitiateCheckout, trackInitiateCheckoutOnly } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  block?: boolean;
  className?: string;
  /** Final purchase button: opens the checkout. Otherwise scrolls to the offer. */
  checkout?: boolean;
};
export function CtaButton({
  children,
  size = 'lg',
  block = false,
  className = '',
  checkout = false
}: CtaButtonProps) {
  const sizes = {
    md: 'px-5 py-2.5 text-[13px]',
    lg: 'min-h-[58px] px-8 py-4 text-[15px] sm:min-h-[64px] sm:px-10 sm:text-base'
  };
  const href = checkout ? checkoutUrl : offerAnchor;
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!checkout) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) {
      trackInitiateCheckoutOnly();
      return;
    }
    e.preventDefault();
    trackInitiateCheckout(href);
  };
  return <a href={href} onClick={handleClick} className={`group inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-full bg-coral font-extrabold uppercase tracking-[0.06em] text-white shadow-cta transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-coral-deep active:translate-y-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-coral ${sizes[size]} ${block ? 'w-full' : ''} ${className}`} data-id="element-63" data-mp="35y7jshpxv30k">
      {children}
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-64" data-mp="3sviv5gb75vjw" />
    </a>;
}